import React, { PureComponent } from 'react'
import { Button, Container, Modal, Row, Col, Tab, Tabs, Image } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import GridRow from '../../api/GovDonor/GridRow'
import CurrentServiceHistory from '../OrderResults/EmployeeDetails/CurrentServiceHistory'
import EditGovDonorForm from './EditGovDonorForm'
import IVRLogForm from './IVRLogForm'

const IVRLogKey = "ivr-log"
const GeneralInformation = "general-informatioh"
const ServiceKey = "service"

interface GovDonorDetailsProps {
  details: GridRow
  onHide: (hasUpdates: boolean) => void
}

interface GovDonorDetailsState {
  currentTab: string
  editing: boolean
}

export default class GovDonorDetailsModal extends PureComponent<GovDonorDetailsProps, GovDonorDetailsState> {
  state = { currentTab: GeneralInformation, editing: false }

  handleSuccessful = () => {
    this.props.onHide(true)
  }

  render() {
    const { PersonID, FirstName, LastName, EmployerID, GovAccessCode } = this.props.details
    return (
      <Modal backdrop="static" size="xl" show dialogClassName="dark" onHide={() => this.props.onHide(false)}>
        <Modal.Header closeButton><Modal.Title className="text-uppercase">Donor Details</Modal.Title></Modal.Header>
        <Modal.Body className="p-0">
          <Container className="tab-container p-0">
            <Row className="px-0 pt-2">
              <Col md={4}>
                <h4 className="px-4"><span className="text-uppercase">{`${LastName}, ${FirstName}`}</span> - {EmployerID}</h4>
              </Col>
              <Col md={5}>
                <h4>Access Code: {GovAccessCode}</h4>
              </Col>
              <Col md={3}>
                <Link className="btn btn-secondary" to={{ pathname: "/gov-order", state: { formData: [this.props.details], pendingRandom: false } }}>ORDER TEST</Link>
              </Col>
            </Row>
            <Row className="px-0 pt-2">
              <Col>
                <Tabs defaultActiveKey={IVRLogKey} activeKey={this.state.currentTab} className="px-4 py-2" onSelect={(eventKey) => { eventKey && this.setState({ currentTab: eventKey }) }}>
                  <Tab eventKey={GeneralInformation} title="GENERAL INFORMATION" tabClassName="rounded-pill px-4">
                    {GeneralInformation === this.state.currentTab && <EditGovDonorForm row={this.props.details} onSuccess={() => this.handleSuccessful()} onHide={this.props.onHide} editing={false} PersonID={PersonID} />}
                  </Tab>
                  <Tab eventKey={IVRLogKey} title="IVR Log" tabClassName="rounded-pill px-4">
                    {IVRLogKey === this.state.currentTab && <IVRLogForm PersonID={PersonID} />}
                  </Tab>
                  {<Tab eventKey={ServiceKey} title="CURRENT SERVICE DETAILS" tabClassName="rounded-pill px-4">
                    {ServiceKey === this.state.currentTab && <CurrentServiceHistory PersonID={PersonID} isOntrack />}
                  </Tab>}
                </Tabs>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        {this.state.currentTab !== GeneralInformation && <Modal.Footer>
          <Button variant="secondary" onClick={() => this.props.onHide(false)} className="px-4">Close</Button>
        </Modal.Footer>}
      </Modal>
    )
  }
}
